import { Api } from 'application/interfaces/api';

import { getGeolocation } from './geolocation';

const other: Api['other'] = {
  getGeolocation,
};

export default other;
